export function cn(...classes) {
  const result = classes.flat().filter(Boolean).join(" ").replace(/\s+/g, " ").trim();

  return result || undefined;
}

export default cn;
